exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.iris-confirm-buttons[data-v-c45a3b06] {\n    display: flex;\n    justify-content: end;\n}\n.action-btn[data-v-c45a3b06] {\n    margin: 0 2px;\n}\n", ""]);

// exports
